/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
import { PrimaryButton } from "../../components";
import { useNavigate } from "react-router";
import { useEffect, useState } from "react";
import { useAuth } from "../../store/useAuth";
import { TomraMachineTable } from "./TomraMachineTable";
import { useTomraMachines } from "../../store/useTomraMachines";

function TomraMachinesScreen() {
  /** Hooks */
  const navigate = useNavigate();
  const { user } = useAuth();
  const { getTomraMachines, allTomraMachines } = useTomraMachines();
  /** State */
  const [page /* setPage */] = useState(1);

  const addTomraMachine = () => navigate("/add-tomra-machine");

  useEffect(() => {
    getTomraMachines(page, 20);
  }, []);

  return (
    <div>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Tomra machines
        </h1>
        {user?.user_role === 1 || user?.user_role === 7 ? (
          <div className="flex flex-col sm:flex-row justify-end sm:items-center">
            <PrimaryButton
              onClick={addTomraMachine}
              label="Register new Tomra Machine"
              className="h-10 mb-1 sm:mb-0"
            />
          </div>
        ) : null}
      </div>
      <div className="w-full px-7 py-7 bg-white rounded-xl border-gray-border drop-shadow-none">
        {!allTomraMachines?.length ? (
          <p className="text-center font-satoshi text-base text-dark">
            There is no Tomra machine created yet.
          </p>
        ) : (
          <TomraMachineTable />
        )}
      </div>
      {/* {hasNextPage ? (
        <div className="flex flex-row w-full items-center justify-end mt-3">
          <PrimaryButton
            onClick={() => {
              setPage(page + 1);
              getArticles(page + 1, 20);
            }}
            label="Load more"
            className="h-10"
          />
        </div>
      ) : null} */}
    </div>
  );
}

export default withProtectedRoute(TomraMachinesScreen);
